export enum SubscriptionCallbackStatus {
  EXPIRED = 'expired', SUCCESS = 'success', CANCEL = 'cancel', PAYMENT_SUCCESS = 'card-update-success', PAYMENT_FAIL = 'card-update-fail'
}